import {sector} from 'constants/url';
import useDelete from 'components/hooks/useDelete';
import {DeletingOptions} from 'components/grid-dx/types';

function useDeleteSector() {
  const deleteSector = useDelete(sector);
  return (deletingOptions: DeletingOptions) => deleteSector(deletingOptions);
}

export default useDeleteSector;
